<router-outlet />

<bn-web-ui-documentation
  [titleFirst]="titleFirst"
  [linksFirst]="linksFirst" />
